export default "__VITE_ASSET__D4e4$AeB__"